// @ts-nocheck
import { createHandlerChainRunner, Handler } from "@toolkit/Modules/client-framework/HandlerCreator";

export type SetIsAddingProductToCartParameter = {
    isAddingProduct?: boolean;
};

type HandlerType = Handler<SetIsAddingProductToCartParameter>;

export const DispatchSetIsAddingProductToCart: HandlerType = props => {
    props.dispatch({
        type: "Store/Components/PartFinder/DispatchSetIsAddingProductToCart",
        isAddingProduct: props.parameter.isAddingProduct,
    });
};

export const chain = [DispatchSetIsAddingProductToCart];

const setIsAddingProductToCart = createHandlerChainRunner(chain, "SetIsAddingProductToCart");
export default setIsAddingProductToCart;
